import {
  BoardNodesProvider,
  SparkBoardContextProvider,
} from 'components/Providers/ContextProviders';
import { BoardContainer } from 'components/common/SparkOutputBoard';
import { useParams } from 'react-router-dom';
import { ReactFlowProvider } from 'reactflow';
import { SparkScrollableGridContainer } from 'sharedComponents/UI';

function SparkBoardBuilder() {
  const { id: boardID } = useParams();

  return (
    <ReactFlowProvider>
      <SparkBoardContextProvider>
        <BoardNodesProvider>
          <SparkScrollableGridContainer
            height='100vh'
            scrollableContainerStyle={{ padding: 0 }}
          >
            <BoardContainer boardID={boardID} />
          </SparkScrollableGridContainer>
        </BoardNodesProvider>
      </SparkBoardContextProvider>
    </ReactFlowProvider>
  );
}

export default SparkBoardBuilder;
